export enum UploadType {
    IMAGE = 'IMAGE',
    IMAGE_URL = 'IMAGE_URL',
    VIDEO_URL = 'VIDEO_URL',
    PDF = 'PDF'
}
